module.exports = __webpack_public_path__ + "static/img/电话-2.2749069f.png";